import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInstitutes } from "../../redux/slice/instituteSlice";
import { useNavigate } from "react-router-dom";

const TrainingInstitutes = ({ searchQuery, locationFilter }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [selectedState, setSelectedState] = useState("");
  const { totalPage, institutes } = useSelector((state) => state.institute);

// Only institutes that completed profile
const validInstitutes = institutes.filter(
  (inst) => inst?.instituteName && inst?.address && inst?.image
);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getInstitutes({ page, limit: 4 }));
  }, [page, dispatch]);

  // Extract unique states from address
  const allStates = [
  ...new Set(
    validInstitutes.map((institute) => {
      const parts = (institute.address || "").split(",");
      return parts[parts.length - 1]?.trim() || "";
    })
  )
];

  // Filter based on search and selected state
 const filteredInstitutes = validInstitutes.filter((institute) => {
  const name = (institute?.instituteName || "").toLowerCase();
  const address = institute?.address || "";

  const nameMatch = name.includes((searchQuery || "").toLowerCase());

  const stateFromAddress = address.split(",").pop()?.trim() || "";

  const matchesStateButton =
    !selectedState || stateFromAddress === selectedState;

  const matchesLocationSearch =
    !locationFilter ||
    address.toLowerCase().includes((locationFilter || "").toLowerCase());

  return nameMatch && matchesStateButton && matchesLocationSearch;
});


  return (
    <div className="container-fluid px-3 px-md-4 px-lg-5 py-4">
      <h4 className="fs_43 ff_inter fw-bold color_darkgray text-center text-md-start mb-4 mb-lg-5">
        Training
        <span className="custom-color"> Institutes</span>
        {selectedState && (
          <span className="fs_18 ms-2 text-muted">
            ({selectedState})
          </span>
        )}
      </h4>

      {/* State Filters */}
      {/* <div className="mb-4 d-flex flex-wrap gap-2 justify-content-center justify-content-md-start">
        {allStates.map((state, index) => {
          const count = institutes.filter((inst) =>
            inst.address.includes(state)
          ).length;
          return (
            <button
              key={index}
              onClick={() => setSelectedState(state)}
              className={`btn btn-sm ${selectedState === state ? "btn-primary" : "btn-outline-primary"}`}
            >
              {state} ({count})
            </button>
          );
        })}
        {selectedState && (
          <button
            onClick={() => setSelectedState("")}
            className="btn btn-sm btn-secondary"
          >
            Clear Filter
          </button>
        )}
      </div> */}

      {/* Institute Cards */}
      <div className="row g-3 g-md-4">
        {filteredInstitutes?.map((obj, index) => (
          <div
            onClick={() => navigate(`/training-institute/${obj._id}`)}
            key={index}
            className="col-12 col-sm-6 col-md-4 col-lg-4"
          >
            <div
              className="card h-100 transtition overflow-hidden rounded-3 border-0"
              style={{
                boxShadow: "0 4px 10px rgba(0, 140, 255, 0.3)",
                cursor: "pointer"
              }}
            >
              <div className="position-relative" style={{ overflow: "visible" }}>
                <div
                  className="position-relative"
                  style={{
                    paddingTop: "50%",
                    overflow: "visible"
                  }}
                >
                  <img
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                    src={obj?.image}
                    alt={`${obj?.instituteName} cover`}
                    style={{ zIndex: 1 }}
                  />
                </div>
              </div>

              <div className="card-body d-flex flex-column p-3">
                <h5 className="fs-6 ff_inter fw-bold color_darkgray mb-2 text-truncate">

                  {obj?.instituteName}<br/>
                  {obj?.address}
                </h5>

                <div className="d-flex flex-column gap-2 mb-3">
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        backgroundColor: "#198754",
                        borderRadius: "50%",
                        width: 20,
                        height: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 8,
                        flexShrink: 0
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="white"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z" />
                      </svg>
                    </div>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 500,
                        color: "#198754",
                        lineHeight: 1.3
                      }}
                    >
                      100% Placement Assistance
                    </span>
                  </div>

                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        backgroundColor: "#198754",
                        borderRadius: "50%",
                        width: 20,
                        height: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 8,
                        flexShrink: 0
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="white"
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-1 18H6V4h12v16z" />
                        <path d="M8 6h2v4H8zm4 0h2v4h-2zm-4 6h2v4H8zm4 0h2v4h-2z" />
                      </svg>
                    </div>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 500,
                        color: "#198754",
                        lineHeight: 1.3
                      }}
                    >
                      100% Hostel Assistance
                    </span>
                  </div>
                </div>

                <div className="mt-auto text-center">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/training-institute/${obj._id}`);
                    }}
                    className="btn btn-primary py-1 px-4 rounded-3 fs-6 fw-normal"
                    style={{ fontSize: "0.8rem" }}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {page !== totalPage && filteredInstitutes.length > 0 && (
        <div className="d-flex justify-content-center mt-4 mt-md-5">
          <button
            onClick={() => setPage(page + 1)}
            className="btn btn-primary px-5 py-2 border-0 rounded-2 fs-5 ff_inter fw-semibold"
          >
            Load More
          </button>
        </div>
      )}

      {filteredInstitutes.length === 0 && (
        <div className="text-center py-5">
          <h5 className="fs-5 ff_inter fw-bold color_darkgray">
            No institutes found matching your search
          </h5>
          <button
            onClick={() => {
              setPage(1);
              setSelectedState("");
            }}
            className="btn btn-outline-primary mt-3"
          >
            Reset Search
          </button>
        </div>
      )}
    </div>
  );
};

export default TrainingInstitutes;
